// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import setPaymentDetailsState from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetPaymentDetailsState";
import xLoadingOverlay from "@west/App/Handlers/XNG/LoadingOverlay";
import { HubSpotInfoParameters, saveHubSpotAdditionalInfo } from "@west/App/Services/HubSpotService";

type HandlerType = Handler<{ isEditing: boolean }, {}>;

export const SetShippingEditing: HandlerType = props => {
    props.dispatch({
        type: "xOnePageCheckout/isShippingEditing",
        isShippingEditing: props.parameter.isEditing,
    } as any);
};

export const UpdatePaymentDetailsState: HandlerType = props => {
    const isBillingAddressUpdateRequired = props.getState().pages.onePageCheckout.isBillingAddressUpdateRequired;
    const isShippingAddressUpdateRequired = props.getState().pages.onePageCheckout.isShippingAddressUpdateRequired;
    if (!isShippingAddressUpdateRequired && !isBillingAddressUpdateRequired && props.parameter.isEditing) {
        props.dispatch(setPaymentDetailsState({ paymentDetailsState: "waiting" }));
    }
};

export const chain = [SetShippingEditing, UpdatePaymentDetailsState];

const setShippingEditing = createHandlerChainRunner(chain, "SetShippingEditing");
export default setShippingEditing;
